import { render, staticRenderFns } from "./flowMatching.vue?vue&type=template&id=1bd4b8d8&scoped=true&"
import script from "./flowMatching.vue?vue&type=script&lang=js&"
export * from "./flowMatching.vue?vue&type=script&lang=js&"
import style0 from "./flowMatching.vue?vue&type=style&index=0&id=1bd4b8d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd4b8d8",
  null
  
)

export default component.exports